import {connect} from 'react-redux'
import withRouter from "../../../../components/RouterComponentWrapper";
import PublicEventoperatorAnsicht from "../../../../components/views/public/eventoperatorneu/PublicEventoperatorAnsicht";
import {NAVIGATION_ITEM} from "../../../../constants/navigationItems";

const mapStateToProps = function (state, ownProps) {
    let eventOperatorId = ownProps.router.location.pathname.substring(NAVIGATION_ITEM.PUBLIC_EVENTOPERATOR.route.length + 1);
    const urlParams = new URLSearchParams(ownProps.router.location.search);
    const tab = urlParams.get('tab');
    const ranking = urlParams.get('ranking');
    let isApp = urlParams.get('app');
    isApp = isApp !== null && isApp !== undefined && isApp.toUpperCase() === "TRUE";
    return {userId: state.user.id, isLoggedIn: state.user.isLoggedIn, eventOperatorId: eventOperatorId, tab:tab, ranking: ranking, appCall: isApp};
};

const mapDispatchToProps = dispatch => ({
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(PublicEventoperatorAnsicht))
